export default __webpack_public_path__ + "static/media/pauseImg.6e35065e.svg";